import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import api from '../../services/api';
import {
  Grid,
  Button,
  TextField,
  Typography,
  Radio,

} from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import { useForm, Controller } from "react-hook-form";


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
}));


const MovPessoal = (props) => {
  const { history } = props;
  const classes = useStyles();
  const { handleSubmit, control } = useForm();
  const [value, setValue] = React.useState('femele');

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const onSubmit = async data => {
    console.log(data.movimentacao);
    props.history.push("./" + data.movimentacao);
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid
          className={classes.content}
          item
          lg={7}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentBody}>
              <form className={classes.form}
                onSubmit={handleSubmit(onSubmit)}
              >
                <Typography className={classes.title} variant="h2">
                  Movimentação de Pessoal
                                </Typography>

                <FormLabel component="legend">Selecione o motivo da MP</FormLabel> 

                <Controller
                  as={
                    <RadioGroup aria-label="gender">
                      <FormControlLabel
                        value="contratacao"
                        control={<Radio />}
                        label="Pedido de contratação"
                      />
                      <FormControlLabel
                        value="promocao"
                        control={<Radio />}
                        label="Promoção"
                      />
                      <FormControlLabel
                        value="regressado"
                        control={<Radio />}
                        label="Pedido de regresso"
                      />
                      <FormControlLabel
                        value="demissao"
                        control={<Radio />}
                        label="Pedido de demissão"
                      />
                      <FormControlLabel
                        value="tranferencia"
                        control={<Radio />}
                        label="Transferência"
                      />
                      <FormControlLabel
                        value="ferias"
                        control={<Radio />}
                        label="Férias"
                      />
                    </RadioGroup>
                  }
                  name="movimentacao"
                  control={control}
                />
                <Button
                  className={classes.signInButton}
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  SELECIONAR
                                </Button>

              </form>
            </div>
          </div>
        </Grid>
      </Grid >
    </div >
  );
};

export default MovPessoal;
